import { Component } from "vue-property-decorator"

import FAppBarBase from "./fAppBar.client.base"

@Component
export default class FAppBarWeb extends FAppBarBase {}
